import { IconProps } from '.';

const ChatIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.5417 32.9847L3.16406 34.8464L5.02576 26.4686C3.83768 24.2469 3.16406 21.7086 3.16406 19.013C3.16406 10.2685 10.2529 3.17969 18.9974 3.17969C27.7418 3.17969 34.8307 10.2685 34.8307 19.013C34.8307 27.7575 27.7418 34.8464 18.9974 34.8464C16.3018 34.8464 13.7635 34.1728 11.5417 32.9847ZM12.0003 29.6388L13.035 30.1921C14.853 31.1643 16.8844 31.6797 18.9974 31.6797C25.993 31.6797 31.6641 26.0087 31.6641 19.013C31.6641 12.0174 25.993 6.34635 18.9974 6.34635C12.0018 6.34635 6.33073 12.0174 6.33073 19.013C6.33073 21.126 6.84609 23.1574 7.81826 24.9754L8.37158 26.0101L7.33482 30.6755L12.0003 29.6388ZM11.0807 19.013H14.2474C14.2474 21.6364 16.374 23.763 18.9974 23.763C21.6208 23.763 23.7474 21.6364 23.7474 19.013H26.9141C26.9141 23.3852 23.3696 26.9297 18.9974 26.9297C14.6251 26.9297 11.0807 23.3852 11.0807 19.013Z"
        fill={color}
      />
    </svg>
  );
};

export default ChatIcon;
